export default {
      id: "ic-misc-search-white-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-misc-search-white-usage",
      toString: function () {
        return this.url;
      }
    }